interface CharLimitLabelProps {
  current: number;
  min?: number;
  max: number;
  showMinLabel?: boolean;
}

export default function CharLimitLabel({ current, min, max, showMinLabel = true }: CharLimitLabelProps) {
  const isOverLimit = current > max;
  const isBelowMin = min !== undefined && current < min && current > 0;
  const isEmpty = current === 0;

  let statusColor = 'text-gray-400';
  if (isOverLimit) statusColor = 'text-red-500';
  else if (isBelowMin) statusColor = 'text-amber-500';
  else if (!isEmpty) statusColor = 'text-emerald-500';

  const parts: string[] = [];
  if (showMinLabel && min !== undefined && min > 0) {
    parts.push(`min ${min}`);
  }
  parts.push(`max ${max}`);

  return (
    <div className="flex items-center justify-between gap-2 mt-1">
      <span className="text-[10px] text-gray-400">{parts.join(' · ')}</span>
      <span className={`text-[10px] font-medium tabular-nums ${statusColor}`}>
        {current}/{max}
      </span>
    </div>
  );
}

interface CharCountProps {
  current: number;
  max: number;
}

export function CharCount({ current, max }: CharCountProps) {
  const isOverLimit = current > max;
  return (
    <span className={`text-[10px] tabular-nums ${isOverLimit ? 'text-red-500 font-medium' : 'text-gray-400'}`}>
      {current}/{max}
    </span>
  );
}